import Icon from "@ant-design/icons";

const SVG = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M16 4H9a3 3 0 0 0-2 5.24" />
    <path d="M8 20h7a3 3 0 0 0 2-5.24" />
    <path d="M4 12h16" />
  </svg>
);

const StrikethroughIcon = (props) => <Icon component={SVG} {...props} />;

export default StrikethroughIcon;
